<!-- 
For expedience for Excellence, just use aurora-avatar here. Finding all references and 
redoing the code to support the aurora model will be done when we do the official switch to Aurora.
-->
<ng-container *sm-has-not-env-flag="'auroraV1'">
    <div class="unity-avatar {{currentColor}} {{size}}"
        [ngClass]="{'disabled': model?.Disabled || state == 'disabled', 'has_image': image, 'pending': state == 'pending'}"
        [ngStyle]="{'background-image': (image) ? 'url(' + image + ')' : null}"
        [ngbTooltipSticky]="userInfo"
        [placement]="['bottom','auto']">
        <svg [ngClass]="{'icon-completing p-1': !model}">
            <use *ngIf="!model" xlink:href="#icon-completing"></use>
            <text *ngIf="model" x="50%" y="50%" dominant-baseline="central" text-anchor="middle" class="initials">{{model?.Initials}}</text>
        </svg>
    </div>
    <ng-template #userInfo>
        <div class="user_info">
            <h2 class="user_info--name">{{model?.Name}}<i *ngIf="model?.Disabled" class="text-muted"> (disabled)</i></h2>
            <div class="user_info--title">{{model?.Title}}</div>
            <div class="user_info--email"><a class="on_dark" href="mailto:{{model?.Email}}">{{model?.Email}}</a></div>
        </div>
    </ng-template>
</ng-container>
<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-avatar [user]="auroraUser" [size]="size" [isCurrentUser]="model?.IsCurrentUser" [color]="auroraCurrentColor"></aurora-avatar>
</ng-container>
